import { LayoutBreakpoint, layoutBreakpoints } from './workspaceLayoutSettings';

export const getActiveLayoutBreakpoint = (width: number) => {
  return layoutBreakpoints.find(
    ({ minWidth }) => width >= minWidth,
  ) as LayoutBreakpoint;
};
